import axios from 'axios';

import {
  callApiPatch,
  callApiPost,
  callApiGet,
  constructApiUrl,
  callApiPut,
} from './common';

class Api {
  static API_HOST = '';

  getUrl(service) {
    return constructApiUrl(Api.API_HOST, service);
  }

  callApiPost(service, params, dispatch, headers = null, consents = false) {
    return callApiPost(this.getUrl(service), params, dispatch, false,
      true, headers, consents);
  }

  callApiGet(service, params, dispatch, headers = null, consents = false) {
    return callApiGet(this.getUrl(service), params, dispatch, true, headers, consents);
  }

  callApiPatch(service, params, dispatch, headers = null, consents = false) {
    return callApiPatch(this.getUrl(service), params, dispatch, true, headers, consents);
  }
  callApiPut(service, params, dispatch, headers = null, consents = false) {
    return callApiPut(this.getUrl(service), params, dispatch, true, headers, consents);
  }

  static setDefaultHost(host) {
    axios.defaults.baseURL = host;
  }
}

export default Api;